// utils/api.js
import axios from 'axios';

// const apiBaseMap = {
//   'commissioning.nnnco.io': 'https://www.nnnco.io/v3/api/core',
//   'commissioning.eu.n2n.nnnco.io': 'https://eu.n2n.nnnco.io/v3/api/core',
//   'commissioning.n-hub.neura.co.nz': 'https://www.n-hub.neura.co.nz/v3/api/core',
//   'commissioning.dev-au-v3.n2n.nnnco.io': 'https://api.dev-au-v3.n2n.nnnco.io/v3/api/core'
// };

const apiBaseMap = {
  'commissioning.nnnco.io': 'https://www.commissioning.nnnco.io/v3/api/core',
  'commissioning.eu.n2n.nnnco.io': 'https://www.commissioning.eu.n2n.nnnco.io/v3/api/core',
  'commissioning.n-hub.neura.co.nz': 'https://www.commissioning.n-hub.neura.co.nz/v3/api/core',
  'commissioning.uk.nnnco.io': 'https://www.commissioning.uk.nnnco.io/v3',
  'commissioning.dev-au-v3.n2n.nnnco.io': 'https://www.commissioning.dev-au-v3.n2n.nnnco.io/v3/api/core'
};

const coreApiBaseMap = {
  'commissioning.nnnco.io': 'https://www.nnnco.io/v3/api/core',
  'commissioning.eu.n2n.nnnco.io': 'https://eu.n2n.nnnco.io/v3/api/core',
  'commissioning.n-hub.neura.co.nz': 'https://www.n-hub.neura.co.nz/v3/api/core',
  'commissioning.uk.nnnco.io': 'https://www.commissioning.uk.nnnco.io/v3',
  'commissioning.dev-au-v3.n2n.nnnco.io': 'https://api.dev-au-v3.n2n.nnnco.io/v3/api/core'
};

const rawHostname = window.location.hostname;
const hostname = rawHostname.replace(/^www\./, ''); // remove leading "www."

// Use dev API when running locally
// Relative URL routes through the CRA proxy (package.json "proxy" field) to avoid CORS
const API_BASE = hostname === 'localhost'
  ? '/v3/api/core'
  : (apiBaseMap[hostname] || 'https://www.nnnco.io/v3/api/core');

// Core API base for endpoints that live on the core service (not commissioning service)
const CORE_API_BASE = hostname === 'localhost'
  ? 'https://api.dev-au-v3.n2n.nnnco.io/v3/api/core'
  : (coreApiBaseMap[hostname] || 'https://www.nnnco.io/v3/api/core');

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { authorization: `Bearer ${token}` } } : {};
};

export const loginUser = async (email, password) => {
  const res = await axios.post(`${API_BASE}/login`, { email, password });
  return res.data;
};

export const getDeviceDetails = async (devEui) => {
  const url = `${API_BASE}/commissioning/devices/${devEui}`;
  const res = await axios.get(url, getAuthHeader());
  return res.data;
};

export const getDeviceDiagnostics = async (devEui) => {
  const url = `${API_BASE}/commissioning/devices/${devEui}/diagnostics`;
  const res = await axios.get(url, getAuthHeader());
  return res.data;
};

export const getDeviceTypes = async () => {
  const url = `${API_BASE}/commissioning/device-types`;
  const res = await axios.get(url, getAuthHeader());
  return res.data;
};

export const getDeviceFields = async (typeId) => {
  const url = `${API_BASE}/commissioning/device-types/${typeId}`;
  const res = await axios.get(url, getAuthHeader());
  return res.data || [];
};

export const updateDeviceType = async (deviceId, deviceType) => {
  const token = localStorage.getItem('token');
  const res = await axios.put(
    `${API_BASE}/devices/${deviceId}/type`,
    { deviceType },
    { headers: { authorization: `Bearer ${token}` } }
  );
  return res; 
};

export const updateDeviceMetadata = async (deviceId, metadata) => {
  const token = localStorage.getItem('token');
  return await axios.put(
    `${API_BASE}/devices/${deviceId}/custom-metadata`,
    metadata,
    { headers: { authorization: `Bearer ${token}` } }
  );
};

export const updateDeviceLocation = async (deviceId, { latitude, longitude }) => {
  const token = localStorage.getItem('token');
  return await axios.put(
    `${API_BASE}/devices/${deviceId}/location`,
    { latitude, longitude },
    { headers: { authorization: `Bearer ${token}` } }
  );
};

export const getDeviceImages = async (deviceId) => {
  const token = localStorage.getItem('token');
  const res = await axios.get(
    `${CORE_API_BASE}/devices/${deviceId}/images`,
    { headers: { authorization: `Bearer ${token}` } }
  );
  return res.data; 
};

export const deleteDeviceImage = async (deviceId, imageId) => {
  const token = localStorage.getItem('token');
  await axios.delete(
    `${CORE_API_BASE}/devices/${deviceId}/images/${imageId}`,
    { headers: { authorization: `Bearer ${token}` } }
  );
};

// api-endpoint from el to deal with uploading images
export const uploadDeviceImage = async (deviceId, file) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('image', file);
  const res = await axios.post(
    `${CORE_API_BASE}/devices/${deviceId}/images`,
    formData,
    {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  );
  return res.data.imageUrl;
};


